import { QuoteInterface } from '../quote/quote.interface';

export enum QuoteBlockSideEnum {
  LEFT = 'left',
  RIGHT = 'right',
}

export interface QuoteBlockInterface extends QuoteInterface {
  side?: QuoteBlockSideEnum;
  hasBottomBorder?: boolean;
}
